<div class="screen">

    <!-- HEADER -->  
    <div class="content">
  
      <!-- LOGO CARD -->
      <div class="logo-card">
  
        <div class="logos">
          <img src="assets/MoMo-logo.png" class="logo mtn" />
          <img src="assets/Thunes@2x.png" class="logo thunes" />
        </div>
  
        <div class="main-heading">
          What Happens Next
        </div>
  
      </div>
  
      <!-- CONTENT CARD -->
      <div class="card">
  
        <div class="section-title">Next steps</div>
  
        <ol class="list">
          <li>You will be redirected to your bank.</li>
          <li>Approve the payment.</li>
          <li>You will return to MoMo automatically.</li>
        </ol>
  
        <div class="section-title">By continuing, you agree that:</div>
  
        <ol class="list">
          <li>The FX rate, fees, and final amount are confirmed at approval.</li>
          <li>Your bank or card issuer may charge additional fees.</li>
          <li>You will be credited only after successful authorization and name verification.</li>
          <li>The account or card name must match your MoMo profile.</li>
          <li>Bank transfers may take 1–3 business days.</li>
          <li>Failed transactions will be refunded by your bank or card issuer.</li>
          <li>All transactions are subject to wallet limits and regulatory checks.</li>
        </ol>
  
        <!-- CHECKBOX -->
        <div class="checkbox-row">
          <p-checkbox [(ngModel)]="agreed" binary="true"></p-checkbox>
  
          <span>
            I agree to the
            <span class="link">Terms and Conditions.</span>
          </span>
        </div>
  
        <!-- BUTTON -->
        <button
          pButton
          label="AGREE & PROCEED"
          class="proceed-btn"
          [disabled]="!agreed"
          (click)="proceed()"
        ></button>
  
      </div>
  
    </div>
  
  </div>